export default __webpack_public_path__ + "static/sampling-config-dark-mode-b2ad26e7d59cdd66e50f56e9b5895666.png";